import React, { useContext, useEffect, useState } from 'react';
import { addcontext } from '../ContextShare/ContextShare';
import { searchMain } from '../Services/allApi';
import { useNavigate } from 'react-router-dom';
import SearchBarCommon from './FilterSearchCommon';
import { toast } from 'react-toastify';
import language from '../language.json'
import './searchbar.css'
import FilterSearchCommon from './FilterSearchCommon';

function Searchbar() {
    const {isSearchOrAdSearch,setIsSearchOrAdSearch}=useContext(addcontext)
    const{totalSearchResultsNS,seTtotalSearchResultsNS}=useContext(addcontext)
    const {paginationStartIndex,setPaginationStartIndex}=useContext(addcontext)
    const {paginationEndIndex,setPaginationEndIndex}=useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();
    const {langChanged,setlangChanged}=useContext(addcontext)
    const {searchError,setSearchError}=useContext(addcontext)
    const [searchValue, setSearchValue] = useState('');
    const [placeholder, setPlaceholder] = useState('Search by KLA, Sessions, Events, Members..');
    const { isFilterOpenC, setFilterOpenC } = useContext(addcontext);
    const { setFilterSearchResults } = useContext(addcontext);
    const{InitialSearchQuery,setInitialSearchQuery}=useContext(addcontext)

    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem('language')||'en')

    },[currentLanguage,langChanged])
    useEffect(() => {
        if (isSearchOrAdSearch === 's') {
            setSearchValue(InitialSearchQuery);
        }
    }, [isSearchOrAdSearch, InitialSearchQuery]);
    

    useEffect(() => {
        // Function to update placeholder based on screen size
        const updatePlaceholder = () => {
            if (window.innerWidth < 768) {
                setPlaceholder(currentLanguage=='en'?'Search here...':'തിരയുക...');
            } else {
                setPlaceholder(language.searchMain[currentLanguage]);
            }
        };

        // Update placeholder when component mounts
        updatePlaceholder();

        // Update placeholder when window is resized
        window.addEventListener('resize', updatePlaceholder);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('resize', updatePlaceholder);
        };
    }, [currentLanguage]);


    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleFilterBox = (e) => {
        e.preventDefault();
        setFilterOpenC(true);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if(searchValue){
            SearchApi()
        }
        else{
            toast.warning('Please enter the text to search.')
        }
    };

    const navigate = useNavigate();

    const SearchApi =() => {
        const search_query = { search_query: searchValue };
        // const result = await searchMain(search_query,1,10);
        // setFilterSearchResults(result?.data?.data);
        // setSearchError(result?.response?.data?.message)
        setIsSearchOrAdSearch('s')
        // seTtotalSearchResultsNS(result?.data?.count)
        setPaginationStartIndex(1)
        setPaginationEndIndex(10)

        setInitialSearchQuery(searchValue)
        navigate('/results');
    };

    return (
        <>
            <div className='flex flex-col items-center lg:w-6/12 md:w-6/12 sm:w-7/12 mx-auto mt-5 '>
                <div className='flex flex-row items-center w-full search-bar '>
                    <form className='flex flex-grow bg-white rounded-lg shadow-md h-10 ' onSubmit={handleSearchSubmit}>
                        <input
                            type="text"
                            placeholder={placeholder}
                            value={searchValue}
                            onChange={handleInputChange}
                            className={`${currentLanguage=='mal'?'custom-input':'custom-input-eng'} flex-grow h-10 border border-blue-500 text-blue-900 rounded-l-lg focus:outline-none`}
                        />
                    </form>
                    <button
                        className='h-10 w-10 bg-primary rounded-r-lg text-white hover:bg-primary-dark'
                        onClick={handleSearchSubmit}
                    >
                        <i className="fa-solid fa-magnifying-glass text-lg"></i>
                    </button>

                    <button
                    onClick={handleFilterBox}
                    className={`${currentLanguage=='mal'?'text-xs':'md:text-sm text-xs'} h-10 ms-5 px-4 border rounded-lg bg-white text-gray-900 shadow-md border-blue-500 border-dotted transition ease-out duration-300'`}
                >
                   {language.advanced_search[currentLanguage]}
                </button>
                </div>
                
            </div>

            {isFilterOpenC && (
                <div className='absolute left-0 right-0 mx-auto flex justify-center mt-3' style={{ top: '80px', zIndex: '1001' }}>
                    <FilterSearchCommon />
                </div>
            )}
        </>
    );
}

export default Searchbar;
